import React, { useState, useEffect } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { Col, Input, Row } from "reactstrap";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate, useNavigation } from "react-router-dom";
import { Fn_AddEditData, Fn_DisplayData, Fn_FillListData } from "../../store/Functions";
import { API_WEB_URLS } from "../../constants/constAPI";
import ReactToggle from "react-toggle";
import Select from 'react-select';

function AddEdit_WorkerMaster() {
  const API_URL_SAVE = `${API_WEB_URLS.WorkerMaster}/0/token`;
  const API_URL_EDIT = `${API_WEB_URLS.MASTER}/0/token/WorkerEdit/Id`;
  const API_URL = API_WEB_URLS.MASTER + "/0/token/PointsWithFuel";
  const [state, setState] = useState({
    id: 0,
    formData: {
      Name: "",
      Username: "",
      Password: "",
      F_Points: "",
    },
    FillArray: [],
    isProgress: true,
  });

  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const Id = (location.state && location.state.Id) || 0;
    Fn_FillListData(dispatch, setState, "FillArray", API_URL + "/Id/0");
    if (Id > 0) {
      setState((prevState) => ({
        ...prevState,
        id: Id,
      }));
      Fn_DisplayData(dispatch, setState, Id, API_URL_EDIT);
    }
  }, [location.state, dispatch]);

  const validationSchema = Yup.object({
    Name: Yup.string().required("Name is required"),
    Username: Yup.string().required("Username is required"),
    Password: Yup.string().required("Password is required"),
    F_Points: Yup.string().required("Please select at least one point"),
  });

  const handleSubmit = (values) => {
    const obj = JSON.parse(localStorage.getItem("authUser"));
    const formData = new FormData();
    formData.append("Name", values.Name);
    formData.append("Username", values.Username);
    formData.append("Password", values.Password);
    formData.append("F_Points", values.F_Points);
    formData.append("UserId", obj.uid);

    Fn_AddEditData(
      dispatch,
      setState,
      { arguList: { id: state.id, formData } },
      API_URL_SAVE,
      true,
      "memberid",
      navigate,
      "/workermaster"
    );
  };

  return (
    <div className="page-content">
      <Formik
        initialValues={state.formData}
        enableReinitialize={true}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {({ setFieldValue, values }) => (
          <Form className="form-horizontal">
          
            <Row>
              <Col lg="6" className="mb-3">
                <label htmlFor="Name" className="form-label">
                  Name
                </label>
                <Field className="form-control" type="text" name="Name" />
                <ErrorMessage name="Name" component="div" className="text-danger" />
              </Col>
            </Row>

            <Row>
              <Col lg="6" className="mb-3">
                <label htmlFor="Username" className="form-label">
                  Username
                </label>
                <Field className="form-control" type="text" name="Username" />
                <ErrorMessage name="Username" component="div" className="text-danger" />
              </Col>
            </Row>

            <Row>
              <Col lg="6" className="mb-3">
                <label htmlFor="Password" className="form-label">
                  Password
                </label>
                <Field className="form-control" type="password" name="Password" />
                <ErrorMessage name="Password" component="div" className="text-danger" />
              </Col>
            </Row>

            <Row>
              <Col lg="6" className="mb-3">
                <label htmlFor="F_Points" className="form-label">
                  Select Points
                </label>
                <Input
                  type="select"
                  name="F_Points"
                  multiple
                  onChange={e => {
                    const selectedValues = Array.from(e.target.selectedOptions, option => option.value);
                    setFieldValue("F_Points", selectedValues.join(','));
                  }}
                >
                  {state.FillArray.map(type => (
                    <option 
                      key={type.Id} 
                      value={type.Id}  
                      selected={values.F_Points && 
                        values.F_Points.split(',').includes(type.Id.toString())}
                    >
                      {type.Name}
                    </option>
                  ))}
                </Input>
                <ErrorMessage name="F_Points" component="div" className="text-danger" />
              </Col>
            </Row>

            <Row>
              <Col lg="6" className="mt-3">
                <button type="submit" className="btn btn-primary btn-block">
                  Submit
                </button>
              </Col>
            </Row>
          </Form>
        )}
      </Formik>
    </div>
  );
}

export default AddEdit_WorkerMaster;
